export class AppInfos {
    APP_VERSION_ID!: string;
    APP_VERSION_DISPLAY!: string;
    APP_COMMIT_SHA!: string;
    CODE_SOCIETE?: string;
    NOM_SOCIETE?: string;
    APP_ENVIRONMENT!: string;
    TYPE_LICENCE: any;
    NF525: any;
    DEVICE_ID?: string;
}

export enum ROLE_WORKSPACE_USER {
    SUPER_ADMIN_WORKSPACE = 50,
    ADMIN_WORKSPACE = 100,
    USER_WORKSPACE = 200,
    USER_ORDER_PORTAIL = 300,
}

export const ROLE_WORKSPACE_USER_LABELS: {[key: string]: string} = {
    50: 'Super Administrateur',
    100: 'Administrateur',
    200: 'Utilisateur',
}

export const ROLE_WORKSPACE_USER_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: ROLE_WORKSPACE_USER.ADMIN_WORKSPACE, mDISPLAY_MEMBER: ROLE_WORKSPACE_USER_LABELS[ROLE_WORKSPACE_USER.ADMIN_WORKSPACE] },
    { mVALUE_MEMBER: ROLE_WORKSPACE_USER.USER_WORKSPACE, mDISPLAY_MEMBER: ROLE_WORKSPACE_USER_LABELS[ROLE_WORKSPACE_USER.USER_WORKSPACE] },
];

export class AuthSessionDto {
    SESSION_ID: string;
    ID: string;
    NOM: string;
    PRENOM: string;
    USERNAME: string;
    EMAIL: string;
    ROLE_ID: ROLE_WORKSPACE_USER;
    HAS_DEFAULT_PASSWORD: boolean;
    AccessToken: string;
    RefreshToken: string;
    NF525: boolean;
    APP_VERSION: string;

    DOMAINE?: string | null;
    INTERFACE_ID?: CLU_MOBILE_INTERFACE | null;
    USER_PERMS: any[];
    CODE_PIN: string;
    MFA_ENABLED: boolean;
    TYPE_LICENCE: TYPES_LICENCES;
    LICENCE_DATE_EXPIRATION: string;

    IS_LOCKED: boolean | null;
}

export class PaginatedResults<T> {
    mDatas: T[] = [];
    mCountTotal: number;
    mPageSize: number;
    mPageNumber: number;
    mIsDatasFiltered?: boolean;

    constructor() {
        this.mDatas = [];
        this.mCountTotal = 0;
        this.mPageSize = 0;
        this.mPageNumber = 0;
        this.mIsDatasFiltered = false;
    }
}

export class AbsPaginatedGrid<T> {
    mAbsColumns: AbsColumn[];
    mColumns: string[];
    mColumnNames: string[];
    mPagination: PaginatedResults<T>;
    mTotalDatas: number;

    constructor() {
        this.mAbsColumns = [];
        this.mColumns = [];
        this.mColumnNames = [];
        this.mPagination = new PaginatedResults();
        this.mTotalDatas = 0;
    }
}

export class AbsColumn {
    mDatasource!: string;
    mTitle!: string;
    mType!: TYPE_COLONNE;
    mTypeDonnees!: TYPE_DONNEE;
    mVisible!: boolean;
    mTemplate?: string;
    mHasCustomHtml?: boolean;
    width?: number;
}

export enum TYPE_COLONNE {
    DIMENSION = 0,
    VALEUR = 1,
    VIRTUEL = 2
}

export enum TYPE_DONNEE {
    NUMERIQUE = 0,
    STRING = 1,
    DATETIME = 2,
    NUMERIQUE_POIDS = 3,
    NUMERIQUE_TEMPS = 4,
    NUMERIQUE_MONTANT = 5,
    BOOLEAN = 6,
    DATE = 7
}

export enum TYPE_RUNNER_JOB_ID {
    SAGE_100_C_SYNCHRONISATION_STRUCTURES = 100,
    SYNCHRONISATION_TICKETS = 200,
    SAGE_100_C_SYNCHRONISATION_STOCK = 500,
    PORTAIL_ORDER_SYNCHRONISATION_COMMANDES = 600
}

export const TYPE_RUNNER_JOB_ID_LABELS: {[key: string]: string} = {
    100: '[SAGE100C] - Synchronisation du paramétrage',
    200: '[CAURISLINKUP] - Synchronisation des tickets',
    500: '[SAGE100C] - Synchronisation des stocks',
    600: '[CAURISLINKUP] - Synchronisation des commandes',
}

export class AbsDSOptionsItems {
    mVALUE_MEMBER!: any;
    mDISPLAY_MEMBER!: string;
}

export const TYPE_RUNNER_JOB_ID_OPTIONS: AbsDSOptionsItems[] = [
    { mVALUE_MEMBER: TYPE_RUNNER_JOB_ID.SAGE_100_C_SYNCHRONISATION_STRUCTURES, mDISPLAY_MEMBER: TYPE_RUNNER_JOB_ID_LABELS[TYPE_RUNNER_JOB_ID.SAGE_100_C_SYNCHRONISATION_STRUCTURES] },
    { mVALUE_MEMBER: TYPE_RUNNER_JOB_ID.SYNCHRONISATION_TICKETS, mDISPLAY_MEMBER: TYPE_RUNNER_JOB_ID_LABELS[TYPE_RUNNER_JOB_ID.SYNCHRONISATION_TICKETS] },
];

export class BaseQueryParams {
    protected _maxPageSize: number = 500;
    PageSize: number = 10;
    PaginationEnabled: boolean = true;
    PageNumber: number = 1;
    OrderByColumn: string = "ID";
    OrderByDirection: string = "DESC";
    DateDebut?: Date;
    DateFin?: Date;
    IDS?: any[];
    SearchValue: string = '';
    SOMMEIL_FILTER = -1;
}

export enum STATUS_TASK {
    ECHEC = -2,
    ANNULE = -1,
    EN_ATTENTE = 0,
    EN_COURS = 1,
    TERMINE = 2,
}

export const STATUS_TASK_LABELS: {[key: string]: string} = {
    '-2': 'Echec',
    '-1': 'Annulé',
    '0': 'En attente',
    '1': 'En cours',
    '2': 'Terminé',
}

export class Model_RunnerTask {
    ID: number;
    GUID_SYNCHRONISATION: string;
    DATE_SYNCHRONISATION: string;
    IS_SYNCED: boolean;
    LIBELLE_TASK: string;
    TYPE_TASK: TYPE_RUNNER_JOB_ID;
    TASK_PARAMS: Model_RunnerTaskJob;
    STATUS_TASK: STATUS_TASK;
    DATE_DEBUT: string;
    DATE_FIN: string;
    RESULT_JOB: string;
    DATE_CREATION: string;
    DATE_MODIFICATION: string;
    DATE_SUPPRESSION: string;
    USER_ID: string;
    PROGRESSION_TASK: number;
    TOTAL_DATAS_SIZE_IN_MB: number;

    NOM_ALIAS?: string;
}

export class Model_RunnerTaskJob {
    JOB_ID: string;
    TYPE_JOB: TYPE_RUNNER_JOB_ID;
    JOB_PARAMS: any;
    STATUS_JOB: STATUS_TASK;
    DATE_DEBUT: string;
    DATE_FIN: string;
    RESULT_JOB: string;
}
export class AuthSessionDtoFO extends AuthSessionDto {
    SITE_ITEM? : any;
    FO_PARAMS? : any;
    LAST_SITE_CASHDESK_SYNC_ITEM?: any;
}

export enum RUNNER_STATUS {
    NO_RUNNER = 0,
    PENDING_REGISTRATION = 1,
    RUNNER_REGISTERED = 2,
}

export const RUNNER_STATUS_COLORS: {[key: string]: string} = {
    0: '#DDDDDD',
    1: "#f5b420",
    2: "#56ef4c",
}

export const RUNNER_STATUS_LABELS: {[key: string]: string} = {
    0: 'Aucune installation',
    1: "Runner en attente d'activation",
    2: "Runner activé",
}

export enum TYPE_MODELE_IMPRESSION {
    RECEIPT = 1,
    X_CAISSE = 2,
    FACTURE = 3,
    BON_ACHAT = 4,
    CHEQUE = 5,
    Z_CAISSE = 6,
    CARTE_CADEAU = 7,
    DUPLICATA = 8,
    DUPLICATA_FACTURE = 9,
    DUPLICATA_BON_ACHAT = 10,
    PAYMENT_RECEIPT = 11,
    DUPLICATA_PAYMENT_RECEIPT = 12,
    X_CAISSE_A4 = 13,
    Z_CAISSE_A4 = 14,
    RECEIPT_BT = 15,

    TICKET_RETOUR_A4 = 16,
    DUPLICATA_TICKET_RETOUR_A4 = 17,
    RECU_REGLEMENT_A4 = 18,
    DUPLICATA_RECU_REGLEMENT_A4 = 19,
}

export const TYPE_MODELE_IMPRESSION_LABELS: {[key: string]: string} = {
    '1': 'Ticket de vente',
    '2': "Arrêt de caisse",
    '3': "Ticket de vente A4",
    '4': "Ticket de retour",
    '5': "Chèque",
    '6': "Clôture Z",
    '7': "Carte cadeau",
    '8': "Duplicata ticket de vente",
    '9': "Duplicata ticket de vente A4",
    '10': "Duplicata ticket de retour",
    '11': "Reçu de règlement",
    '12': "Duplicata reçu de règlement",
    '13': 'Arrêt de caisse A4',
    '14': 'Clôture Z A4',
    '15': 'Ticket de vente BT',

    '16': 'Ticket de retour A4',
    '17': 'Duplicata ticket de retour A4',
    '18': 'Reçu de règlement A4',
    '19': 'Duplicata reçu de règlement A4',
}

export const TYPE_MODELE_IMPRESSION_OPTIONS = [
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.RECEIPT, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.RECEIPT] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.X_CAISSE, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.X_CAISSE] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.X_CAISSE_A4, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.X_CAISSE_A4] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.Z_CAISSE, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.Z_CAISSE] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.Z_CAISSE_A4, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.Z_CAISSE_A4] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.BON_ACHAT, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.BON_ACHAT] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.CARTE_CADEAU, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.CARTE_CADEAU] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.FACTURE, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.FACTURE] },
    //{ mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.CHEQUE, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.CHEQUE] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.DUPLICATA, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.DUPLICATA] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.DUPLICATA_FACTURE, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.DUPLICATA_FACTURE] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.DUPLICATA_BON_ACHAT, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.DUPLICATA_BON_ACHAT] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.PAYMENT_RECEIPT, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.PAYMENT_RECEIPT] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.DUPLICATA_PAYMENT_RECEIPT, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.DUPLICATA_PAYMENT_RECEIPT] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.RECEIPT_BT, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.RECEIPT_BT] },

    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.TICKET_RETOUR_A4, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.TICKET_RETOUR_A4] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.DUPLICATA_TICKET_RETOUR_A4, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.DUPLICATA_TICKET_RETOUR_A4] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.RECU_REGLEMENT_A4, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.RECU_REGLEMENT_A4] },
    { mVALUE_MEMBER: TYPE_MODELE_IMPRESSION.DUPLICATA_RECU_REGLEMENT_A4, mDISPLAY_MEMBER: TYPE_MODELE_IMPRESSION_LABELS[TYPE_MODELE_IMPRESSION.DUPLICATA_RECU_REGLEMENT_A4] },
];


export const TYPES_MODELES_THERMAL_PRINT = [
    TYPE_MODELE_IMPRESSION.RECEIPT, TYPE_MODELE_IMPRESSION.DUPLICATA,
    TYPE_MODELE_IMPRESSION.BON_ACHAT, TYPE_MODELE_IMPRESSION.DUPLICATA_BON_ACHAT,
    TYPE_MODELE_IMPRESSION.PAYMENT_RECEIPT, TYPE_MODELE_IMPRESSION.DUPLICATA_PAYMENT_RECEIPT,
    TYPE_MODELE_IMPRESSION.X_CAISSE, TYPE_MODELE_IMPRESSION.Z_CAISSE
];

export enum CLU_MOBILE_INTERFACE {
    FRONTOFFICE = 100,
    BACKOFFICE = 200
}

export enum APP_MODE {
    WEB = 'WEB',
    MOBILE = 'MOBILE'
}

export const MOBILE_VIEW_S = 'screen and (max-width: 375px)';
export const MOBILE_VIEW_L = 'screen and (max-width: 425px)';
export const MOBILE_VIEW = 'screen and (max-width: 768px)';
export const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
export const MONITOR_VIEW = 'screen and (min-width: 1024px)';
export const BELOWMONITOR = 'screen and (max-width: 1023px)';
export const BELOWMONITOR_L = 'screen and (max-width: 1440px)';
export const BELOWMONITOR_M = 'screen and (max-width: 768px)';
export const BELOWMONITOR_L1100 = 'screen and (max-width: 1099px)';

export enum TYPE_USER_PROFIL {
    ADMIN = 1,
    USER = 2
}

export const TYPE_USER_PROFIL_LABELS: {[key: string]: string} = {
    '1': "Profil Admin",
    '2': "Profil User",
}

export const TYPE_USER_PROFIL_OPTIONS = [
    { mVALUE_MEMBER: TYPE_USER_PROFIL.ADMIN, mDISPLAY_MEMBER: TYPE_USER_PROFIL_LABELS[TYPE_USER_PROFIL.ADMIN] },
    { mVALUE_MEMBER: TYPE_USER_PROFIL.USER, mDISPLAY_MEMBER: TYPE_USER_PROFIL_LABELS[TYPE_USER_PROFIL.USER] },
];



export enum USER_PERMISSION_POLICY {
    UNAUTHORIZED = '-1',
    ALLOW = '1',
    ALLOW_BY_CONTROL = '2'
}

export const USER_PERMISSION_POLICY_LABELS: {[key: string]: string} = {
    '-1': 'Non autorisé',
    '1': "Autorisé",
    '2': "Autorisé via visa",
}

export const USER_PERMISSION_POLICY_OPTIONS = [
    { mVALUE_MEMBER: USER_PERMISSION_POLICY.UNAUTHORIZED, mDISPLAY_MEMBER: USER_PERMISSION_POLICY_LABELS[USER_PERMISSION_POLICY.UNAUTHORIZED] },
    { mVALUE_MEMBER: USER_PERMISSION_POLICY.ALLOW, mDISPLAY_MEMBER: USER_PERMISSION_POLICY_LABELS[USER_PERMISSION_POLICY.ALLOW] },
    { mVALUE_MEMBER: USER_PERMISSION_POLICY.ALLOW_BY_CONTROL, mDISPLAY_MEMBER: USER_PERMISSION_POLICY_LABELS[USER_PERMISSION_POLICY.ALLOW_BY_CONTROL] },
];

export enum INSTALLATION_STATUS_ALIAS {
    DESACTIVE = 0,
    NON_INSTALLE = 1,
    INSTALLATION_EN_COURS = 2,
    INSTALLE = 3,
    MISE_A_JOUR_DISPONIBLE = 4,
    MISE_A_JOUR_EN_COURS = 5,
}

export const INSTALLATION_STATUS_ALIAS_LABELS: {[key: string]: string} = {
    '0': 'Desactivé',
    '1': "Non installé",
    '2': "Installation en cours",
    '3': "Installé",
    '4': "Mise à jour disponible",
    '5': "Mise à jour en cours",
}

export const INSTALLATION_STATUS_ALIAS_OPTIONS = [
    { mVALUE_MEMBER: INSTALLATION_STATUS_ALIAS.DESACTIVE, mDISPLAY_MEMBER: INSTALLATION_STATUS_ALIAS_LABELS[INSTALLATION_STATUS_ALIAS.DESACTIVE] },
    { mVALUE_MEMBER: INSTALLATION_STATUS_ALIAS.NON_INSTALLE, mDISPLAY_MEMBER: INSTALLATION_STATUS_ALIAS_LABELS[INSTALLATION_STATUS_ALIAS.NON_INSTALLE] },
    { mVALUE_MEMBER: INSTALLATION_STATUS_ALIAS.INSTALLATION_EN_COURS, mDISPLAY_MEMBER: INSTALLATION_STATUS_ALIAS_LABELS[INSTALLATION_STATUS_ALIAS.INSTALLATION_EN_COURS] },
    { mVALUE_MEMBER: INSTALLATION_STATUS_ALIAS.INSTALLE, mDISPLAY_MEMBER: INSTALLATION_STATUS_ALIAS_LABELS[INSTALLATION_STATUS_ALIAS.INSTALLE] },
    { mVALUE_MEMBER: INSTALLATION_STATUS_ALIAS.MISE_A_JOUR_DISPONIBLE, mDISPLAY_MEMBER: INSTALLATION_STATUS_ALIAS_LABELS[INSTALLATION_STATUS_ALIAS.MISE_A_JOUR_DISPONIBLE] },
    { mVALUE_MEMBER: INSTALLATION_STATUS_ALIAS.MISE_A_JOUR_EN_COURS, mDISPLAY_MEMBER: INSTALLATION_STATUS_ALIAS_LABELS[INSTALLATION_STATUS_ALIAS.MISE_A_JOUR_EN_COURS] },
];


export enum TYPE_AUTOMATE_JOB_ID {
    SAGE_LINK_SYNCHRONIZATION_PARAMS_DATAS = 1,
    SAGE_LINK_SYNCHRONIZATION_STOCKS = 2
}

export const TYPE_AUTOMATE_JOB_ID_LABELS: {[key: string]: string} = {
    '1': '[SAGE100C] - Synchronisation du paramétrage',
    '2': '[SAGE100C] - Synchronisation des stocks'
}

export const TYPE_AUTOMATE_JOB_ID_OPTIONS = [
    { mVALUE_MEMBER: TYPE_AUTOMATE_JOB_ID.SAGE_LINK_SYNCHRONIZATION_PARAMS_DATAS, mDISPLAY_MEMBER: TYPE_AUTOMATE_JOB_ID_LABELS[TYPE_AUTOMATE_JOB_ID.SAGE_LINK_SYNCHRONIZATION_PARAMS_DATAS] },
    { mVALUE_MEMBER: TYPE_AUTOMATE_JOB_ID.SAGE_LINK_SYNCHRONIZATION_STOCKS, mDISPLAY_MEMBER: TYPE_AUTOMATE_JOB_ID_LABELS[TYPE_AUTOMATE_JOB_ID.SAGE_LINK_SYNCHRONIZATION_STOCKS] },
];

export enum PERIODICITE_AUTOMATE {
    RECURENTE = 1,
    PONCTUELLE = 2,
}

export const PERIODICITE_AUTOMATE_LABELS: {[key: string]: string} = {
    '1': 'Recurente',
    '2': 'Ponctuelle'
}

export const PERIODICITE_AUTOMATE_OPTIONS = [
    { mVALUE_MEMBER: PERIODICITE_AUTOMATE.RECURENTE, mDISPLAY_MEMBER: PERIODICITE_AUTOMATE_LABELS[PERIODICITE_AUTOMATE.RECURENTE] },
    { mVALUE_MEMBER: PERIODICITE_AUTOMATE.PONCTUELLE, mDISPLAY_MEMBER: PERIODICITE_AUTOMATE_LABELS[PERIODICITE_AUTOMATE.PONCTUELLE] },
];

export enum STATUS_PLANIFICATION {
    ECHEC = -2,
    ANNULE = -1,
    EN_ATTENTE = 0,
    EN_COURS = 1,
    TERMINE = 2,
}

export enum THERMAL_PRINTER_WIDTH_PAPER {
    PAPER_WIDTH_58MM = '58mm',
    PAPER_WIDTH_80MM = '80mm',
}

export const THERMAL_PRINTER_WIDTH_PAPER_LABELS: {[key: string]: string} = {
    '58mm': 'Papier 58mm',
    '80mm': 'Papier 80mm'
}

export const THERMAL_PRINTER_WIDTH_PAPER_OPTIONS = [
    { mVALUE_MEMBER: THERMAL_PRINTER_WIDTH_PAPER.PAPER_WIDTH_58MM, mDISPLAY_MEMBER: THERMAL_PRINTER_WIDTH_PAPER_LABELS[THERMAL_PRINTER_WIDTH_PAPER.PAPER_WIDTH_58MM] },
    { mVALUE_MEMBER: THERMAL_PRINTER_WIDTH_PAPER.PAPER_WIDTH_80MM, mDISPLAY_MEMBER: THERMAL_PRINTER_WIDTH_PAPER_LABELS[THERMAL_PRINTER_WIDTH_PAPER.PAPER_WIDTH_80MM] },
];

export const DEFAULT_DISPLAY_DEVICE_MESSAGES = [
    { ID: '_WELCOME_TEXT_',	DESCRIPTION: 'Message de bienvenue', TEXT1: 'Bienvenue', TEXT2: 'Cauris Linkup' },
    { ID: '_OPENING_TICKET_', DESCRIPTION: 'Ouverture de ticket',	TEXT1: 'Ticket en cours', TEXT2: '@[DO_NB_LIGNES] article(s)' },
    { ID: '_ADD_ITEM_TO_CART_',	DESCRIPTION: 'Ajout d\'un article au panier', TEXT1: '@[DL_DESIGN]', TEXT2: 'Total: @[DO_TOTALTTC]' },
    { ID: '_INIT_PAYMENT_',	DESCRIPTION: 'Initialisation des paiements', TEXT1: 'Paiement en cours…', TEXT2: 'Solde: @[DO_SOLDETTC]' },
    { ID: '_INIT_PAYMENT_MODE_', DESCRIPTION: 'Initialisation d\'un mode de paiement',	TEXT1: 'Paiement @[N_REGLEMENTLIB]', TEXT2: 'Solde: @[DO_SOLDETTC]' },
    { ID: '_SAVE_PAYMENT_',	DESCRIPTION: 'Enregistrement d\'un paiement', TEXT1: 'Paiement: @[N_REGLEMENTLIB]', TEXT2: 'Restant: @[DO_SOLDETTC]' },
    { ID: '_VALIDATE_PAYMENT_',	DESCRIPTION: 'Validation des paiements', TEXT1: 'Paiement effectué', TEXT2: 'Merci' },
];

export enum REMDOCS_DOMAINE {
    VENTE = 0,
    ACHAT = 1,
    STOCKS = 2,
    INTERNE = 4
}

export const REMDOCS_DOMAINE_LABELS: {[key: string]: string} = {
    '0': 'VENTE',
    '1': 'ACHAT',
    '2': 'STOCKS',
    '4': 'DOCUMENTS INTERNES'
}

export const REMDOCS_DOMAINE_OPTIONS = [
    { mVALUE_MEMBER: REMDOCS_DOMAINE.VENTE, mDISPLAY_MEMBER: REMDOCS_DOMAINE_LABELS[REMDOCS_DOMAINE.VENTE] },
    { mVALUE_MEMBER: REMDOCS_DOMAINE.ACHAT, mDISPLAY_MEMBER: REMDOCS_DOMAINE_LABELS[REMDOCS_DOMAINE.ACHAT] },
    { mVALUE_MEMBER: REMDOCS_DOMAINE.STOCKS, mDISPLAY_MEMBER: REMDOCS_DOMAINE_LABELS[REMDOCS_DOMAINE.STOCKS] },
    { mVALUE_MEMBER: REMDOCS_DOMAINE.INTERNE, mDISPLAY_MEMBER: REMDOCS_DOMAINE_LABELS[REMDOCS_DOMAINE.INTERNE] },
];

export enum REMDOCS_TYPE_DOCUMENT {
    VENTE_DEVIS = 0,
    VENTE_BON_COMMANDE = 1,
    VENTE_PREPARATION_LIVRAISON = 2,
    VENTE_BON_LIVRAISON = 3,
    VENTE_BON_RETOUR = 4,
    VENTE_BON_AVOIR = 5,
    VENTE_FACTURE = 6,
    VENTE_FACTURE_COMPTABILISEE = 7,

    ACHAT_DEMANDE_ACHAT = 10,
    ACHAT_PREPARATION_COMMANDE = 11,
    ACHAT_BON_COMMANDE = 12,
    ACHAT_BON_LIVRAISON = 13,
    ACHAT_BON_RETOUR = 14,
    ACHAT_BON_AVOIR = 15,
    ACHAT_FACTURE = 16,
    ACHAT_FACTURE_COMPTABILISEE = 17,

    STOCKS_MOUVEMENT_ENTREE = 20,
    STOCKS_MOUVEMENT_SORTIE = 21,
    STOCKS_DEPRECIATION_STOCK = 22,
    STOCKS_VIREMENT_DEPOT_DEPOT = 23,
    STOCKS_PREPARATION_FABRICATION = 24,
    STOCKS_ORDRE_FABRICATION = 25,
    STOCKS_BON_FABRICATION = 26,

    DOCUMENT_INTERNE_1 = 40,
    DOCUMENT_INTERNE_2 = 41,
    DOCUMENT_INTERNE_3 = 42,
    DOCUMENT_INTERNE_4 = 43,
    DOCUMENT_INTERNE_5 = 44,
    DOCUMENT_INTERNE_6 = 45,
}

export const REMDOCS_TYPE_DOCUMENT_LABELS: {[key: string]: string} = {
    '0': 'Devis',
    '1': 'Bon de commande',
    '2': "Préparation de livraison",
    '3': "Bon de livraison",
    '4': "Bon de retour",
    '5': "Bon d'avoir",
    '6': "Facture",
    '7': "Facture comptabilisée",

    '10': "Demande d'achat",
    '11': "Préparation de commande",
    '12': "Bon de commande",
    '13': "Bon de livraison",
    '14': "Bon de retour",
    '15': 'Bon d\'avoir',
    '16': 'Facture',
    '17': 'Facture comptabilisée',

    '20': 'Mouvement d\'entrée',
    '21': 'Mouvement de sortie',
    '22': 'Dépréciation de stock',
    '23': 'Virement de dépôt à dépôt',
    '24': 'Préparation de fabrication',
    '25': 'Ordre de fabrication',
    '26': 'Bon de fabrication',

    '40': 'Document interne 1',
    '41': 'Document interne 2',
    '42': 'Document interne 3',
    '43': 'Document interne 4',
    '44': 'Document interne 5',
    '45': 'Document interne 6',
    '46': 'Document interne 7',
}


export const REMDOCS_TYPE_DOCUMENT_OPTIONS = [
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_DEVIS, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_DEVIS], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_BON_COMMANDE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_BON_COMMANDE], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_PREPARATION_LIVRAISON, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_PREPARATION_LIVRAISON], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_BON_LIVRAISON, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_BON_LIVRAISON], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_BON_RETOUR, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_BON_RETOUR], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_BON_AVOIR, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_BON_AVOIR], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_FACTURE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_FACTURE], DOMAINE: REMDOCS_DOMAINE.VENTE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.VENTE_FACTURE_COMPTABILISEE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.VENTE_FACTURE_COMPTABILISEE], DOMAINE: REMDOCS_DOMAINE.VENTE },

    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_DEMANDE_ACHAT, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_DEMANDE_ACHAT], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_PREPARATION_COMMANDE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_PREPARATION_COMMANDE], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_BON_COMMANDE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_BON_COMMANDE], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_BON_LIVRAISON, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_BON_LIVRAISON], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_BON_RETOUR, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_BON_RETOUR], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_BON_AVOIR, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_BON_AVOIR], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_FACTURE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_FACTURE], DOMAINE: REMDOCS_DOMAINE.ACHAT },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.ACHAT_FACTURE_COMPTABILISEE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.ACHAT_FACTURE_COMPTABILISEE], DOMAINE: REMDOCS_DOMAINE.ACHAT },

    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_MOUVEMENT_ENTREE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_MOUVEMENT_ENTREE], DOMAINE: REMDOCS_DOMAINE.STOCKS },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_MOUVEMENT_SORTIE, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_MOUVEMENT_SORTIE], DOMAINE: REMDOCS_DOMAINE.STOCKS },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_DEPRECIATION_STOCK, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_DEPRECIATION_STOCK], DOMAINE: REMDOCS_DOMAINE.STOCKS },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_VIREMENT_DEPOT_DEPOT, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_VIREMENT_DEPOT_DEPOT], DOMAINE: REMDOCS_DOMAINE.STOCKS },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_PREPARATION_FABRICATION, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_PREPARATION_FABRICATION], DOMAINE: REMDOCS_DOMAINE.STOCKS },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_ORDRE_FABRICATION, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_ORDRE_FABRICATION], DOMAINE: REMDOCS_DOMAINE.STOCKS },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.STOCKS_BON_FABRICATION, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.STOCKS_BON_FABRICATION], DOMAINE: REMDOCS_DOMAINE.STOCKS },

    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_1, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_1], DOMAINE: REMDOCS_DOMAINE.INTERNE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_2, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_2], DOMAINE: REMDOCS_DOMAINE.INTERNE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_3, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_3], DOMAINE: REMDOCS_DOMAINE.INTERNE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_4, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_4], DOMAINE: REMDOCS_DOMAINE.INTERNE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_5, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_5], DOMAINE: REMDOCS_DOMAINE.INTERNE },
    { mVALUE_MEMBER: REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_6, mDISPLAY_MEMBER: REMDOCS_TYPE_DOCUMENT_LABELS[REMDOCS_TYPE_DOCUMENT.DOCUMENT_INTERNE_6], DOMAINE: REMDOCS_DOMAINE.INTERNE },
];

export enum REMDOCS_TYPE_IMPRESSION {
    STANDARD = 1,
    THERMIQUE = 2,
    BLUETOOTH = 3,
}

export const REMDOCS_TYPE_IMPRESSION_LABELS: {[key: string]: string} = {
    1: 'Impression standard',
    2: 'Impression thermique',
    3: "Impression bluetooth",
}


export const REMDOCS_TYPE_IMPRESSION_OPTIONS = [
    { mVALUE_MEMBER: REMDOCS_TYPE_IMPRESSION.THERMIQUE, mDISPLAY_MEMBER: REMDOCS_TYPE_IMPRESSION_LABELS[REMDOCS_TYPE_IMPRESSION.THERMIQUE] },
    { mVALUE_MEMBER: REMDOCS_TYPE_IMPRESSION.STANDARD, mDISPLAY_MEMBER: REMDOCS_TYPE_IMPRESSION_LABELS[REMDOCS_TYPE_IMPRESSION.STANDARD] },
    { mVALUE_MEMBER: REMDOCS_TYPE_IMPRESSION.BLUETOOTH, mDISPLAY_MEMBER: REMDOCS_TYPE_IMPRESSION_LABELS[REMDOCS_TYPE_IMPRESSION.BLUETOOTH] },
];


export enum TYPES_LICENCES {
    NFR = 25,
    TRY_AND_BUY = 50,
    PROD = 75,
}

export const TYPES_LICENCES_LABELS: {[key: string]: string} = {
    25: 'NFR',
    50: 'TRY & BUY',
    75: "PROD",
}
export class AuthSessionOrderPortailDto extends AuthSessionDto {
    RAISON_SOCIALE: string;
    TELEPHONE: string;
    ADRESSE: string;
}

export enum ORDER_PORTAIL_STOCK_DISPLAY_MODE {
    HIDDEN = 0,
    SHOW_QUANTITY_STATUS = 1,
    SHOW_QUANTITY_VALUE = 2
}

export const ORDER_PORTAIL_STOCK_DISPLAY_MODE_LABELS: {[key: number]: string} = {
    0: 'Ne rien afficher',
    1: 'Afficher le status de la quantité',
    2: "Afficher la valeur de la quantité",
}

export const ORDER_PORTAIL_STOCK_DISPLAY_MODE_COLORS: {[key: number]: string} = {
    0: 'bg-light',
    1: 'bg-orange',
    2: "bg-green",
}

export const ORDER_PORTAIL_STOCK_DISPLAY_MODE_OPTIONS = [
    { mVALUE_MEMBER: ORDER_PORTAIL_STOCK_DISPLAY_MODE.HIDDEN, mDISPLAY_MEMBER: ORDER_PORTAIL_STOCK_DISPLAY_MODE_LABELS[ORDER_PORTAIL_STOCK_DISPLAY_MODE.HIDDEN] },
    { mVALUE_MEMBER: ORDER_PORTAIL_STOCK_DISPLAY_MODE.SHOW_QUANTITY_STATUS, mDISPLAY_MEMBER: ORDER_PORTAIL_STOCK_DISPLAY_MODE_LABELS[ORDER_PORTAIL_STOCK_DISPLAY_MODE.SHOW_QUANTITY_STATUS] },
    { mVALUE_MEMBER: ORDER_PORTAIL_STOCK_DISPLAY_MODE.SHOW_QUANTITY_VALUE, mDISPLAY_MEMBER: ORDER_PORTAIL_STOCK_DISPLAY_MODE_LABELS[ORDER_PORTAIL_STOCK_DISPLAY_MODE.SHOW_QUANTITY_VALUE] },
];

export enum ORDER_PORTAIL_STATUS_STOCK {
    NO_STOCK = 0,
    LOW_STOCK = 1,
    AVAILABLE_STOCK = 2
}

export const ORDER_PORTAIL_STATUS_STOCK_LABELS: {[key: number]: string} = {
    0: 'En rupture de stock',
    1: 'Disponible',
    2: "Disponible",
}

export const ORDER_PORTAIL_STATUS_STOCK_COLORS: {[key: number]: string} = {
    0: 'bg-danger text-white',
    1: 'bg-light text-black',
    2: "bg-light text-black",
}
